<template>
  <label class="switch">
    <input class="inp" type="checkbox" :checked="checkedValue" @change="onChangeValue()" />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  name: 'GfToggle',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    checkedValue: false,
  }),
  watch: {
    checked(val) {
      this.checkedValue = val;
    },
  },
  created() {
    // Lấy giá trị từ props truyền vào để làm mặc định
    this.checkedValue = this.checked;
  },
  methods: {
    onChangeValue() {
      this.checkedValue = !this.checkedValue;
      this.$emit('onChange', this.checkedValue);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.switch {
  position: relative;
  display: inline-block;
  width: 28px;
  padding-bottom: 0;

  .inp {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: $newPrimary;
    }

    &:focus + .slider {
      @include boxshadow(0 0 1px $newPrimary);
    }

    &:checked + .slider:before {
      -webkit-transform: translateX(13px);
      -ms-transform: translateX(13px);
      transform: translateX(13px);
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: $black3;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    width: 28px;
    height: 15px;

    &:before {
      position: absolute;
      content: '';
      height: 13px;
      width: 13px;
      left: 1px;
      bottom: 1px;
      background-color: #fff;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
    -moz-border-radius: 34px;
    -webkit-border-radius: 34px;

    &:before {
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
    }
  }
}
</style>
